import { SagaIterator } from 'redux-saga';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import { DeleteContents, EditWorkbook, NewWorkbookForDatasource, SetContentPermissions, SetOwner, SetTabsWorkbook, SetTags, OpenWorkbookInDesktopDialog, NewWorkbookForEditDatasource } from '../../../actions/AppActionTypes';
import { deleteContents } from '../content/DeleteContentsSaga';
import { setContentPermissions } from '~permissions/sagas/SetContentPermissionsSaga';
import { handleSetTags } from '../SetTagsSagas';
import { handleEditWorkbookAction } from './EditWorkbookSaga';
import { handleNewWorkbookForDatasourceAction } from './NewWorkbookForDatasourceSagas';
import { handleSetOwner } from './SetOwnerSagas';
import { setTabsWorkbookSaga } from './SetTabsWorkbookSaga';
import { handleOpenWorkbookInDesktop } from './OpenWorkbookInDesktopSaga';
import { handleNewWorkbookForEditDatasourceAction } from './NewWorkbookForEditDatasource';

export function* rootWorkbookSaga(): SagaIterator {
  yield takeEvery(SetOwner, handleSetOwner);
  yield takeEvery(SetTabsWorkbook, setTabsWorkbookSaga);
  yield takeLatest(SetTags, handleSetTags);
  yield takeEvery(DeleteContents, deleteContents);
  yield takeLatest(SetContentPermissions, setContentPermissions);
  yield takeEvery(EditWorkbook, handleEditWorkbookAction);
  yield takeEvery(OpenWorkbookInDesktopDialog, handleOpenWorkbookInDesktop);
  yield takeEvery(NewWorkbookForDatasource, handleNewWorkbookForDatasourceAction);
  yield takeEvery(NewWorkbookForEditDatasource, handleNewWorkbookForEditDatasourceAction);
}
